export default __webpack_public_path__ + "static/gba_ep6_compressed-1071379d2f1843759bf1f74bf1a6ca1d.mp4";